<passepartout *ngIf="showDesktopLayout"></passepartout>
<app-menu-bar *ngIf="!showDesktopLayout"
              [lang]="selectedLanguage"
              (changeLanguageEvent)="change($event)">
</app-menu-bar>
<router-outlet></router-outlet>
